(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drop-fit-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drop-fit-guide')) {
    customElements.define('drop-fit-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready || typeof HTMLDialogElement === 'undefined') return;
        const panel = this.querySelector('.drop-fit__panel');
        const trigger = this.querySelector('summary');
        if (!panel || !trigger) return;
        this.dataset.ready = 'true';
        const dialog = document.createElement('dialog');
        dialog.className = 'drop-fit__dialog';
        dialog.setAttribute('aria-labelledby', panel.querySelector('h2').id);
        dialog.id = panel.querySelector('h2').id + '-dialog';
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        dialog.append(panel);
        this.append(dialog);
        const close = panel.querySelector('.drop-fit__close');
        close.hidden = false;
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow;
          trigger.focus({preventScroll:true});
        });
        trigger.addEventListener('click', event => {
          event.preventDefault();
          const info = this.closest('.launch-product__info');
          const chosen = info?.querySelector('.launch-sizes input:checked');
          const size = chosen?.labels?.[0]?.textContent.trim();
          panel.querySelectorAll('[data-fit-size]').forEach(row => row.toggleAttribute('data-selected', row.dataset.fitSize === size));
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
          dialog.scrollTop = 0;
          close.focus({preventScroll:true});
        });
      }
      disconnectedCallback() {
        if (this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drop-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drop-gallery')) {
  customElements.define('drop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.drop-gallery__track');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.links = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.active = 0;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-index]');
        if (link && this.contains(link)) { event.preventDefault(); this.show(Number(link.dataset.galleryIndex)); }
        if (event.target.closest('[data-gallery-prev]')) this.show(this.active - 1);
        if (event.target.closest('[data-gallery-next]')) this.show(this.active + 1);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const actions = { ArrowLeft: this.active - 1, ArrowRight: this.active + 1, Home: 0, End: this.slides.length - 1 };
        if (Object.hasOwn(actions, event.key)) { event.preventDefault(); this.show(actions[event.key]); }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.select(Math.round(this.track.scrollLeft / this.track.clientWidth)));
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.active * this.track.clientWidth, behavior: 'instant' });
      });
      this.resizeObserver.observe(this.track);
      this.select(0);
    }
    show(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    select(index) {
      if (!Number.isFinite(index)) return;
      this.active = Math.max(0, Math.min(this.slides.length - 1, index));
      this.links.forEach((link, i) => { if (i === this.active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
      const count = this.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${this.active + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resizeObserver?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
